import React from 'react';
import { Link, useParams, generatePath } from 'react-router-dom';

import {useDataValue} from 'globals/contexts/dataContext';

import LandingSection from 'containers/commercialProjectPage/landingSection';
import ProjectListSection from 'containers/commercialProjectPage/projectListSection';
import BannerSection from 'containers/indexPage/bannerSection';

import Footer from 'containers/footer';

import routes from 'globals/routes';

import './commercialProjectPage.css';

const CommercialProjectPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const {project} = useParams();
  const projects = content['content'][currentLanguage]['pages']['commercial']['projects'];
  const filters = {};
  projects['filter'].forEach(filter => {
    filters[filter['type']] = filter;
  })
  if (project) {
    const pageContent = projects['items'].find((proj) => proj['id'] === project);
    return <div id="commercialProject" className="page">
      <LandingSection content={pageContent['details']} filters={filters} />
      <ProjectListSection content={pageContent['details']} filter={filters} />
      {/* <BannerSection content={pageContent['banner']} /> */}
      <div className="backButtonRow">
        <Link to={generatePath(routes.commercialPage, { lang: currentLanguage })} className="backButton">
          {currentLanguage === 'tc'? <>返回<br/>商業作品列表</>:<>Back to<br/>Project Showcase</>}
        </Link>
      </div>
      <Footer />
    </div>;
  } else {
    return null;
  }
};

export default CommercialProjectPage;